// Обработчик для обновления формы кампании
// Направление: server -> client
// Бэкенд присылает сгенерированный черновик кампании (basic-режим, intent=create_draft/edit_draft)
// как { ok, campaign_context: {...} }. Парсим payload и кладём в store — Form.tsx применяет его к форме.
import emitter from "../../core/wsEmitter";
import { store } from "../../../store/store";
import { setCampaignFormUpdate } from "../../../store/slices/session.slice";
import { parseCampaignFormUpdatePayload } from "../../../../pages/main/components/workspace/components/chat/components/form/service/get-session-form.service";

emitter.on("campaign_form.update", (data: unknown) => {
	// eslint-disable-next-line no-console
	console.log("campaign form update", data);

	const { sessionId } = store.getState().session;
	if (!sessionId) return;

	const payload = parseCampaignFormUpdatePayload(data);
	if (!payload) return;

	store.dispatch(setCampaignFormUpdate({ sessionId, payload }));
});
